import React from 'react';
import { Link } from 'react-router-dom';
import './Page.css';

const LicensingCompliance = () => {
  return (
    <div className="page-content">
      <div className="container">
        <h1>Licensing and Compliance</h1>
        
        <p>QuantumSync is committed to maintaining the highest standards of regulatory compliance and transparency.</p>
        
        <div className="compliance-info">
          <div className="compliance-card">
            <h2>Company Information</h2>
            <p><strong>Company Name:</strong> QuantumSync s.r.o. C 388554</p>
            <p><strong>Registration Number:</strong> C 388554</p>
            <p><strong>Registered Address:</strong> Cimburkova 916/8, Žižkov, 130 00 Praha 3, Czech Republic</p>
          </div>
          
          <div className="compliance-card">
            <h2>Regulatory Status</h2>
            <p>QuantumSync is registered as a Virtual Asset Service Provider to offer provision of services connected with a virtual asset.</p>
          </div>
        </div>
        
        <h2>Compliance Documents</h2>
        <p>For detailed information about our compliance and licensing, please review the following documents:</p>
        
        <div className="compliance-links">
          <Link to="/kyc-aml-policy" className="compliance-link-card">
            <h3>KYC & AML Policy</h3>
            <p>Our Know Your Customer and Anti-Money Laundering procedures</p>
          </Link>
          
          <Link to="/terms-and-conditions" className="compliance-link-card">
            <h3>Terms & Conditions</h3>
            <p>Complete terms and conditions for using our platform</p>
          </Link>
          
          <Link to="/privacy-policy" className="compliance-link-card">
            <h3>Privacy Policy</h3>
            <p>How we collect, use, and protect your personal data</p>
          </Link>
          
          <Link to="/cookie-policy" className="compliance-link-card">
            <h3>Cookie Policy</h3>
            <p>Information about cookies and how we use them</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LicensingCompliance;
